import { useEffect, useRef, useState } from "react"
import { OverlayTrigger, Popover } from "react-bootstrap";
import { origin, getpostalcodes, HideLoder, LogInSchoolID, LogInUserID, ShowLoder, MMDDYYYY, typewatch, formatDecimal } from "../../JS/Common";
import { ApiCmnHeadersPostCall, ApiGetCall, ApiGetCallAuthKey, ApiGetCDNData, ApiPostCall } from "../../JS/Connector";
import { useNavigate } from "react-router-dom";
import AlertsComp from "../../Components/AlertsComp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faTimes } from "@fortawesome/free-solid-svg-icons";
import 'bootstrap/dist/css/bootstrap.min.css';
import Deletepopup from "../../Components/Deletepopup";
import Popup from "../../Components/Popup";
import SignatureCanvas from "react-signature-canvas";
import { CheckValidation, ValidateFile } from "../../Components/Validations";
import Pagination from "react-js-pagination";
import { log } from "../../JS/Logger";
import { useSelector } from "react-redux";
import useConfig from "../../Hooks/useConfig";

import PizZip from "pizzip";
import Docxtemplater from "docxtemplater";
export function Setup() {
    const { organization, services_dcc_link, student, students, twenty_percent_off_text, compliance_note_text, small_student,
        enterprise_name, secondary_text, school, dcc_module_text, left_menu_dcc_text, compliance_note_heading,
        offset_repair_cost_suffix, offset_repair_cost_prefix, how_it_works, getting_started, dcc_administration_agreement
    } = useConfig();
    const [mainimage, setmainimage] = useState(false);
    const [firstLoad, setFirstLoad] = useState(true);
    const [Loading, setLoading] = useState(false);
    const [NewAlerts, setNewAlerts] = useState("");
    const [RejectedReason, setRejectedReason] = useState("");
    const [planid, setplanid] = useState("");
    const [GridData, setGridData] = useState([]);
    const [ContractModal, setContractModal] = useState(false);
    const [EditData, setEditData] = useState({})
    const [resetFilter, setResetFilter] = useState('d-none')
    const [searchstring, setsearchstring] = useState(null)
    const [SortFlag, setSortFlag] = useState(null)
    const [activeFilter, setActiveFilter] = useState(null);
    const [ChangedPrice, setChangedPrice] = useState('');
    const [Confirmbtn, setConfirmbtn] = useState('');
    const [RejectedDiv, setRejectedDiv] = useState('d-none');
    const [CounterOfferDiv, setCounterOfferDiv] = useState('d-none');
    const [ContractUrl, setContractUrl] = useState('');
    const [policyPopup, setPolicyPopup] = useState(false);
    const [showdeletepopup, setshowdeletepopup] = useState(false);
    const [policyFileName, setPolicyFileName] = useState('')
    const [policyDocument, setPolicyDocument] = useState(null)
    const [showcopymsg, setshowcopymsg] = useState(false);
    const [Description, setDescription] = useState("");
    const [NewFile, setNewFile] = useState(0);
    const [PolicyFlag, setPolicyFlag] = useState(0);
    const navigate = useNavigate()

    const now = new Date();
    const formattedDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    const labelRef = useRef(null);
    const [schoolAgreementPopup, setSchoolAgreementPopup] = useState(false);
    const [schoolAgreementPopupId, setSchoolAgreementPopupId] = useState('');
    const [isSchoolAgreementFlag, setisSchoolAgreementFlag] = useState(null);
    const [showAgreementError, setShowAgreementError] = useState(false);
    const [isSchoolAgreementChecked, setIsSchoolAgreementChecked] = useState(true);
    const [agreementExpiryDate, setAgreementExpiryDate] = useState(new Date());
    const [agreementFile, setAgreementFile] = useState(null);
    const [AllState, setallstate] = useState([]);
    const [SignatureData, setSignatureData] = useState(null)
    const [SignatureError, setSignatureError] = useState('')
    const signatureCanvas = useRef({});
    const [agreementDetails, setAgreementDetails] = useState({
        schoolname: "",
        streetline1: "",
        streetline2: "",
        city: "",
        state: "",
        postalCode: "",
        firstname: "",
        lastname: ""
    })
    const [LimitForPagination, setLimitForPagination] = useState(25);
    const [pageRangeCount, setpageRangeCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const showPagination = GridData?.length > 0;
    const itemsPerPage = LimitForPagination;
    const StateData = useSelector((state) => state.authData);

    useEffect(() => {
        GetAddress();
        getpostalcodes(setallstate);
    }, []);

    useEffect(() => {
        GetGridData(null, null);
    }, [currentPage, LimitForPagination]);

    async function GetGridData(flag, searchstring) {
        if (searchstring?.trim() == "") {
            searchstring = null;
        } else {
            searchstring = searchstring?.trim() || null;
        };
        const isInitialLoad = (flag === null || flag === undefined) && (searchstring === null || searchstring === "");
        if (flag != null) {
            setResetFilter('')
        } else {
            setResetFilter('d-none')
            setActiveFilter(null)
        }
        typewatch(async function () {
            setLoading(true);
            await ApiGetCall(`/plans/insurance/all?schoolId=${LogInSchoolID}&search=${encodeURIComponent(searchstring)}&planFlag=${encodeURIComponent(flag)}&page=${encodeURIComponent(currentPage)}&limit=${encodeURIComponent(LimitForPagination)}`).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    const responseRs = JSON.parse(result);
                    setLoading(false);
                    const hasPlans = responseRs?.plan?.data?.length > 0;
                    setGridData(hasPlans ? responseRs?.plan?.data : []);
                    setContractUrl(hasPlans ? responseRs.url : '');
                    setisSchoolAgreementFlag(responseRs.parental_agreement_flag);
                    if (responseRs.parental_agreement_flag !== 1) {
                        setIsSchoolAgreementChecked(false);
                    }
                    setAgreementExpiryDate(responseRs.parental_agreement_expiry ? new Date(responseRs.parental_agreement_expiry) : new Date());
                    setAgreementFile(responseRs.agreement);
                    setpageRangeCount(responseRs?.plan?.total)
                    if (!hasPlans && isInitialLoad) {
                        setmainimage(true);      // show setup screen
                        setFirstLoad(true);
                    } else {
                        setmainimage(false);     // hide setup screen on filtered empty result
                        setFirstLoad(false);
                    }
                }
            });
        }, 500)
    }
    async function GetAddress() {
        await ApiGetCall(`/schools/address?schoolId=${LogInSchoolID}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                var shippingaddress = responseRs.school_address;
                setAgreementDetails({
                    ...agreementDetails, schoolname: responseRs?.school_detail?.name,
                    streetline1: shippingaddress.street_line,
                    streetline2: shippingaddress.street_line2,
                    city: shippingaddress.city,
                    state: shippingaddress.state_or_province_code,
                    postalCode: shippingaddress.postal_code,
                    firstname: responseRs.user_details?.first_name,
                    lastname: responseRs.user_details?.last_name
                });
            }
        });
    }

    async function ViewDetails(id) {
        setLoading(true);
        setConfirmbtn('');
        setCounterOfferDiv('d-none')
        setRejectedDiv('d-none')
        setContractModal(true);
        await ApiGetCall(`/plans/insurance/by-id?planId=${id}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setEditData(responseRs)
                setLoading(false);
            }
        });
    }
    async function ConfirmContract(id, PlanNum, PlanName, SchoolName, flag, agreementFlag) {
        if (isSchoolAgreementChecked || agreementFlag == 1) {
            setShowAgreementError(false);
            if (agreementFlag ? agreementFlag : isSchoolAgreementFlag === 1) {
                setLoading(true);
                var raw = JSON.stringify({
                    schoolId: LogInSchoolID,
                    planId: id,
                    planNum: PlanNum,
                    planName: PlanName,
                    schoolName: SchoolName,
                    flag: flag,
                    negotiatedPrice: ChangedPrice ? ChangedPrice : 0,
                    startDate: formattedDate,
                    rejectedReason: RejectedReason
                });
                await ApiPostCall("/plans/insurance/confirm", raw).then((result) => {
                    if (result == undefined || result == "") {
                        alert("Something went wrong");
                    } else {
                        setLoading(false);
                        if (result == "success") {
                            var msg = flag == 1 ? `${dcc_module_text} Confirmed!` : flag == 2 ? 'Proposal Send Successfully' : 'Proposal Rejected!';
                            setNewAlerts(<AlertsComp show={true} variant="success" msg={msg} />);
                            setContractModal(false)
                            setTimeout(() => {
                                setNewAlerts(<AlertsComp show={false} />);
                                GetGridData(null, null)
                            }, 1500);
                        }
                        else {
                            setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                            setTimeout(() => {
                                setNewAlerts(<AlertsComp show={false} />);
                            }, 2000);
                        }
                    }
                });
            } else {
                setSchoolAgreementPopupId(id);
                GetAddress();
                getpostalcodes(setallstate);
                setSchoolAgreementPopup(true);
            }
        } else {
            setShowAgreementError(true);
        }
    }
    const handleCopyClick = () => {
        if (labelRef.current) {
            const labelValue = labelRef.current.innerText;
            const tempInput = document.createElement('input');
            tempInput.value = labelValue;
            document.body.appendChild(tempInput);
            tempInput.select();
            tempInput.setSelectionRange(0, 99999); // For mobile devices
            document.execCommand('copy');
            document.body.removeChild(tempInput);
            setshowcopymsg(true);
            setTimeout(() => {
                setshowcopymsg(false);
            }, 1500);

        }
    };
    const [showPopover, setShowPopover] = useState(false);

    const popover = (
        <Popover id="popover-basic" style={{ maxWidth: '45%', fontSize: '14px' }} onMouseLeave={() => setShowPopover(false)}>
            <Popover.Header as="h3">What is {dcc_module_text}?</Popover.Header>
            <Popover.Body>
                <p className='secondary-text'>
                    {offset_repair_cost_prefix} <a className='text-decoration-underline whats-cover-text' href={services_dcc_link} target="_blank">{left_menu_dcc_text}</a> {offset_repair_cost_suffix}
                </p>
                <label className='secondary-text fw-bold pb-3'>How It Works:</label>
                <ul className='secondary-text ps-5'>
                    {how_it_works?.map((point, idx) => (
                        <li key={idx}>
                            <b>{point?.title}</b> {point?.description}
                        </li>
                    ))}
                </ul>
                <label className='secondary-text fw-bold py-3'>Getting Started Is Simple:</label>
                <ol className='secondary-text ps-5'>
                    {getting_started?.map((step, idx) => (
                        <li key={idx}>
                            {step.text}
                            {step.sub_points && (
                                <ol type='a'>
                                    {step.sub_points.map((sub, subIdx) => (
                                        <li key={subIdx}>{sub}</li>
                                    ))}
                                </ol>
                            )}
                        </li>
                    ))}
                </ol>
                <label className='secondary-text fw-bold pt-3 pb-2'>{compliance_note_heading}</label>
                <p className='secondary-text'>
                    {compliance_note_text}
                </p>
            </Popover.Body>
        </Popover>
    );
    const handleToggle = (nextShow) => {
        setShowPopover(nextShow);
    };
    function handlePdfFileUpload(e) {
        const file = e.target.files[0];
        if (!file) return;
        const { isFileValid, validationMsg } = ValidateFile(file, { allowedType: "pdf", maxSizeMB: 5 });
        if (!isFileValid) {
            setPolicyFileName(validationMsg);
            return;
        }
        setPolicyFileName(file.name);
        setPolicyDocument(file);
        setNewFile(1);
        setPolicyFlag(1);
    };

    async function UploadPolicyDocument() {
        setLoading(true);

        const formdata = new FormData();
        formdata.append('schoolId', LogInSchoolID);
        if (NewFile == 1 && policyDocument) {
            formdata.append('file', NewFile == 1 ? policyDocument : null);
        }
        formdata.append('flag', PolicyFlag);
        formdata.append('description', Description);

        ApiCmnHeadersPostCall(`/plans/insurance/policies/save`, formdata)
            .then(result => {
                const responseRs = JSON.parse(result);
                if (responseRs.status == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={'Document Updated successfully'} />)
                    setTimeout(function () {
                        setNewAlerts(<AlertsComp show={false} />)
                        setPolicyPopup(false)
                        setPolicyFileName("");
                    }, 2000);
                } else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.status} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                    }, 2000);
                }
                setLoading(false);
            })
            .catch(error => log.error('error', error));
    }
    async function DeletePlan() {
        setLoading(true);
        var raw = JSON.stringify({
            schoolId: LogInSchoolID,
            insurancePlanId: planid
        });
        await ApiPostCall("/plans/insurance/delete-unfinished", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false);
                setshowdeletepopup(false);
                const responseRs = JSON.parse(result);
                if (responseRs.status == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={"Club Deleted Successfully."} />);
                    setTimeout(() => {
                        GetGridData(null, null);
                        setNewAlerts(<AlertsComp show={false} />)
                    }, 1500);
                } else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={responseRs.message} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />);
                    }, 2000);
                }
            }
        });
    }
    const sortGradesString = (gradesString) => {
        const gradesArray = gradesString.split(',');
        gradesArray.sort((a, b) => a.localeCompare(b));
        return gradesArray.join(',');
    };
    const modalbody = (
        <div className="row">
            <div className="col-md-6 d-flex  pb-2 pe-0 wordwrap">
                <div className="col-md-6  fw-600">Club Name : </div>
                <div className="col-md-6 mb-0 schoolColorStatus h5"> {EditData.plan_name}</div>
            </div>
            <div className="col-md-6 d-flex  pb-2 pe-0 wordwrap">
                <div className="col-md-6  fw-600">Estimated  {student} : </div>
                <div className="col-md-6"> {EditData.estimated_enrollment}</div>
            </div>
            <div className="col-md-6 d-flex  py-2 pe-0 wordwrap">
                <div className="col-md-6  fw-600">Contact Name : </div>
                <div className="col-md-6"> {EditData.contact_name}</div>
            </div>
            <div className="col-md-6 d-flex py-2 pe-0 wordwrap">
                <div className="col-md-6  fw-600">Contact Email : </div>
                <div className="col-md-6"> {EditData.contact_email}</div>
            </div>
            <div className="col-md-6 d-flex py-2 pe-0 wordwrap">
                <div className="col-md-6  fw-600">Sign Up Start Date : </div>
                <div className="col-md-6"> {EditData.start_date ? MMDDYYYY(EditData.start_date) : '-'}</div>
            </div>
            <div className="col-md-6 d-flex py-2 pe-0 wordwrap">
                <div className="col-md-6  fw-600">Sign Up End Date : </div>
                <div className="col-md-6"> {EditData.end_date ? MMDDYYYY(EditData.end_date) : '-'}</div>
            </div>
            <div className="col-md-6 d-flex py-2 pe-0 wordwrap">
                <div className="col-md-6  fw-600">{dcc_module_text} Start Date : </div>
                <div className="col-md-6"> {EditData.coverage_start_date ? MMDDYYYY(EditData.coverage_start_date) : '-'}</div>
            </div>
            <div className="col-md-6 d-flex py-2 pe-0 wordwrap">
                <div className="col-md-6  fw-600">{dcc_module_text} End Date : </div>
                <div className="col-md-6"> {EditData.coverage_end_date ? MMDDYYYY(EditData.coverage_end_date) : '-'}</div>
            </div>
            <div className="col-md-6 d-flex py-2 pe-0 wordwrap">
                <div className="col-md-6  fw-600">Grades : </div>
                <div className="col-md-6"> {EditData.grades?.map((item) =>
                    item.name ? item.name : item).join(', ')}</div>
            </div>
            <div className="col-md-6 d-flex py-2 pe-0 wordwrap">
                <div className="col-md-6  fw-600">Device Models Included : </div>
                <div className="col-md-6"> {EditData.device_models}</div>
            </div>
            <div className="col-md-12 d-flex  pt-2 pe-0 wordwrap">
                <div className="col-md-6 fw-600">Percentage of Devices Going Home with {students} : </div>
                <div className="col-md-4"> {EditData.devices_not_leave_school}&nbsp;%</div>
            </div>
            <div className="col-md-12 d-flex  pt-2 pe-0 wordwrap">
                <div className="col-md-6 fw-600">{students} keep devices over summer : </div>
                <div className="col-md-4"> {EditData.keep_device_over_summer == 0 ? "No" : "Yes"}</div>
            </div>
            <img src="/images/HorizontalLine.svg" className="img-fluid w-100 my-2 postclass" />
            <div className="row pb-3">
                {EditData?.school?.uncovered_repair_charges == 1 && (
                    <div className="col-md-6 pt-2">
                        <b>Uncoverd Repair Charges :</b> ${EditData.uncovered_charge}
                    </div>
                )}
                <div className="col-md-6 pt-2">
                    <b>{dcc_module_text} Charges :</b> ${EditData.price}
                </div>
            </div>
            <div className={`${CounterOfferDiv}`}>
                <div className="col-md-12 text-center font-14 py-2" style={{ color: 'var(--primary-color)' }}>Do you want to suggest a price to negotiate with {enterprise_name}?</div>
                <div className="input-container col-md-4 offset-md-4 d-flex align-items-center">
                    <input type="number" autoComplete="off" name='totaldevices' defaultValue={ChangedPrice || '0'} placeholder="Enter Price"
                        className="form-control" min={0} onChange={(e) => { setChangedPrice(e.target.value) }}
                        onKeyDown={(e) => {
                            if (["e", "E", "+", "-"]?.includes(e?.key)) {
                                e.preventDefault();
                            }
                        }} />
                    <label><img src='/images/CancelIcon.svg' className="input-icon img-fluid ms-3 cursor-pointer" title={`Back To Confirm ${dcc_module_text}`} onClick={(e) => { setConfirmbtn(''); setCounterOfferDiv('d-none') }} /></label>
                </div>
                <hr />
            </div>
            <div className={`${RejectedDiv}`}>
                <div className="col-md-12 text-center font-14 py-2" style={{ color: 'var(--primary-color)' }}>You are about to reject this offer from {enterprise_name}, please provide a reason for rejection below: </div>
                <div className="input-container col-md-6 offset-md-3 d-flex align-items-center">
                    <textarea type="textarea" rows={2} autoComplete="off" name="rejectreason" className="form-control" defaultValue={RejectedReason} onChange={(e) => setRejectedReason(e.target.value)} />
                    <label><img src='/images/CancelIcon.svg' className="input-icon img-fluid ms-3 cursor-pointer" title={`Back To Confirm ${dcc_module_text}`} onClick={(e) => { setConfirmbtn(''); setRejectedDiv('d-none') }} /></label>
                </div>
                <hr />
            </div>
            {isSchoolAgreementFlag !== 1 && RejectedDiv == 'd-none' && <div className=" row d-flex justify-content-center align-items-center pt-1">
                <div className="col-12">
                    <div className="form-check">

                        <input className="form-check-input" type="checkbox" name="signAggrement" id="signAggrement" checked={isSchoolAgreementChecked} onChange={(e) => { setIsSchoolAgreementChecked(e.target.checked) }} />
                        <label className="form-check-label">
                            <b>
                                {isSchoolAgreementFlag === 2 ?
                                    <>Your <label onClick={(e) => openPDFInNewTab('Administration_Agreement.pdf')} className="cursor-pointer text-decoration-underline whats-cover-text" >club hosting agreement</label> is expired, you agree to renew it</>
                                    : <>I have read and agree to the <label onClick={(e) => openPDFInNewTab('Administration_Agreement.pdf')} className="cursor-pointer text-decoration-underline whats-cover-text" >{dcc_module_text} Administration Agreement</label> and Terms.</>}
                            </b>
                        </label>
                        <span className="custom-text-danger d-block">{showAgreementError ? "*Required" : ""}</span>
                    </div>
                </div>
            </div>}

            <div className="contract-confirm-font pt-2 text-center">If you agree and confirm offered charges from {enterprise_name} then please go ahead and confirm offer. </div>
        </div>
    )
    const modalfooter = (
        <>
            <label className={`ms-2 cursor-pointer ${Confirmbtn}`}
                onClick={(e) => { setConfirmbtn('d-none'); setRejectedDiv('') }}>
                <u>Reject Offer</u>
            </label>
            {/* <button className={`deleteBtn ${Confirmbtn}`} onClick={(e) => { setConfirmbtn('d-none'); setCounterOfferDiv('') }}>Counter Offer  </button> */}
            <button className={`SaveBtn ms-2 ${Confirmbtn}`} onClick={(e) => ConfirmContract(EditData.id, EditData.plan_num, EditData.plan_name, EditData.school_name, 1)}>Confirm Offer</button>
            <button className={`SaveBtn ms-2 ${CounterOfferDiv}`} onClick={(e) => ConfirmContract(EditData.id, EditData.plan_num, EditData.plan_name, EditData.school_name, 2)}>Send Your Proposal</button>
            <button className={`SaveBtn ms-2 ${RejectedDiv}`} onClick={(e) => ConfirmContract(EditData.id, EditData.plan_num, EditData.plan_name, EditData.school_name, 3, 1)}>Reject Offer</button>
        </>
    )
    const policypopup = (
        <>
            <div className="p-1 pe-0 d-flex align-items-center">
                <label className='' ref={labelRef} style={{ wordBreak: 'break-all' }}>
                    <b> {origin}/{ContractUrl}</b>
                </label>
                <FontAwesomeIcon icon={faCopy} style={{ height: "20px" }} className='cursor-pointer ps-3' title='Click to copy this URL' onClick={handleCopyClick} />
            </div>
            <div className="pb-2">
                Copy and share the {dcc_module_text} link for users to easily sign-up
            </div>

            {showcopymsg == true && (
                <div className='px-2 text-center col-md-12' style={{ color: "var(--primary-color)" }}>Copied!</div>
            )}
            <br />
            <div className="col-12 pb-2">
                <div>
                    <label className='fw-600'>Provide instructions for new users: What is a {student} ID # and how do I find it?
                    </label>
                    <textarea type="textarea" rows={3} autoComplete="off" name="description"
                        className="form-control mt-2"
                        value={Description} onChange={(e) => setDescription(e.target.value)} />
                </div>
            </div>

            {NewFile == 2 ?
                <div className="pt-3">
                    <label className="fw-600">Attached Policy Document :</label>
                    <label style={{ fontWeight: "600", color: 'var(--primary-color)', wordBreak: 'break-all' }}>
                        {policyDocument}
                    </label>
                    <img src='/images/pdficon.svg' title="View Document" className='px-3 cursor-pointer' onClick={(e) => openPDFInNewTab(policyDocument)} />
                    <FontAwesomeIcon icon={faTimes} style={{ cursor: 'pointer' }} title='Remove Policy' onClick={(e) => { setPolicyDocument(null); setPolicyFileName(""); setNewFile(0); setPolicyFlag(2) }} />
                </div>
                :
                <div className="col-md-12">
                    <div className="col-md-12 fw-600 pt-2">Upload Fair Use Policy Document:</div>
                    <div className="col-md-12">
                        <input type="file" label="img" id="UploadFileId" name="myFile" accept="application/pdf" onChange={(e) => handlePdfFileUpload(e)} />
                        <label className="ImportInventoryBtn col-md-8" htmlFor="UploadFileId" style={{ color: "#909091" }}>
                            Choose File
                        </label>
                        <input type="file" className="col-md-4 col-9 ImportInventoryBtn" />
                        <label className="ImportInventoryBtn1 text-center col-md-4 col-3" htmlFor="UploadFileId" style={{ backgroundColor: "var(--primary-color)", color: "white", height: "40px", }}>
                            Browse
                        </label>
                    </div>
                    {policyFileName &&
                        <label className="ps-3 mt-1 d-flex" style={{ fontWeight: "600", color: 'var(--primary-color)', wordBreak: 'break-all' }}>{policyFileName} </label>}
                </div>
            }
        </>
    )

    function GetSchoolData() {
        ApiGetCallAuthKey(`/schools/by-number?schoolNumber=${StateData?.Schoolnumber}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                if (responseRs.status == "success") {
                    setPolicyPopup(true)
                    setPolicyFlag(0)
                    setPolicyDocument(responseRs?.msg?.insurance_policy)
                    setDescription(
                        responseRs?.msg?.insurance_notes ||
                        `A ${student || "Student's"} ID number is assigned by your ${organization} district. Locate this number on your ${small_student}'s ${organization} ID card or recent report card. If you have issues, contact the district’s main office.`
                    );
                    if (responseRs?.msg?.insurance_policy) {
                        setNewFile(2)
                    }
                }
            }
        });
    }
    const clearSignatureForPackedBy = () => {
        if (SignatureData != null) {
            setSignatureData(null)
        } else {
            signatureCanvas.current.clear();
        }
    };
    const agreementmodalbody = (
        <div className='row parent' id="AgreementDiv">
            <label>Before proceeding, please sign our Club Hosting Agreement.</label>

            <div className="col-md-12 pt-3">
                <div className='col-12 text-start px-1 font-14 pb-1 new-font-style'>{organization} Name</div>
                <input type="text" autoComplete='off' name='schoolname' disabled
                    className="form-control" value={agreementDetails.schoolname}
                />
            </div>
            <div className="col-md-6 pt-3">
                <div className='col-12 text-start px-1 pb-1 shipdevice-font-style'>Street Line 1*</div>
                <input type="text" autoComplete='off' name='streetline1' className="form-control"
                    required value={agreementDetails.streetline1}
                    onChange={(e) => setAgreementDetails({ ...agreementDetails, streetline1: e.target.value })} />
                <span className="form-text invalid-feedback" >
                    *required
                </span>
            </div>
            <div className="col-md-6 pt-3">
                <div className='col-12 text-start px-1 pb-1 shipdevice-font-style'>Street Line 2</div>
                <input type="text" autoComplete='off' name='streetline2' className="form-control"
                    value={agreementDetails.streetline2}
                    onChange={(e) => setAgreementDetails({ ...agreementDetails, streetline2: e.target.value })} />
            </div>
            <div className="col-md-6 pt-3">
                <div className='col-12 text-start px-1 pb-1 shipdevice-font-style'>City*</div>
                <input type="text" autoComplete='off' name='City' className="form-control" required
                    value={agreementDetails.city} onChange={(e) => setAgreementDetails({ ...agreementDetails, city: e.target.value })} />
                <span className="form-text invalid-feedback" >
                    *required
                </span>
            </div>
            <div className="col-md-6 pt-3">
                <div className='col-12 text-start px-1 pb-1 shipdevice-font-style'>State*</div>
                <select required onChange={(e) => setAgreementDetails({ ...agreementDetails, state: e.target.value })}>
                    <option value="0">Select</option>
                    {AllState.map((item, i) => {
                        return <option value={item.state_code} selected={agreementDetails.state == item.state_code}>{item.state_code}</option>
                    })}
                </select>
                <span className="form-text invalid-feedback" >
                    *required
                </span>
            </div>
            <div className="col-md-6 pt-3">
                <div className='col-12 text-start px-1 pb-1 shipdevice-font-style'>Postal Code</div>
                <input type="number" autoComplete='off' name='postalcode' className="form-control"
                    value={agreementDetails.postalCode}
                    onChange={(e) => setAgreementDetails({ ...agreementDetails, postalCode: e.target.value })}
                    onKeyDown={(e) => {
                        if (["e", "E", "+", "-"]?.includes(e?.key)) {
                            e.preventDefault();
                        }
                    }} />
            </div>
            <div className="col-md-6 pt-3">
                <div className='col-12 text-start px-1 pb-1 shipdevice-font-style'>Country</div>
                <input type="text" autoComplete='off' value='US' disabled name='City' className="form-control" />
            </div>
            <div className="col-12 pt-3 text-center">
                <button className="SaveBtn" onClick={() => { handleSignAgreement(true) }}>Preview Agreement</button>
            </div>
            <div className="col-12 pt-3">
                <div className="greyBox">
                    <div className='fw-600 font-15 text-center'>Add Signature:</div>
                    <div className='mt-2 text-center'>
                        <SignatureCanvas
                            ref={signatureCanvas}
                            canvasProps={{ width: 430, height: 100, className: "signatureCanvas" }}
                        />
                    </div>
                    <div className="text-end"> <label className="cursor-pointer" onClick={clearSignatureForPackedBy}><u>Clear</u></label></div>
                </div>
                <h6 className="redText">{SignatureError}</h6>
            </div>

        </div>
    );
    const handleSignAgreement = async (isPreview = false) => {
        var isFormValid = CheckValidation({ formID: 'AgreementDiv' });
        var signatureBase64 = null;
        if (SignatureData == null) {
            signatureBase64 = signatureCanvas.current.isEmpty() ? null : signatureCanvas.current.getTrimmedCanvas().toDataURL("image/png");
        } else {
            signatureBase64 = SignatureData
        }
        if (signatureBase64 == null && !isPreview) {
            setSignatureError("*required");
            isFormValid = false;
        } else {
            setSignatureError("");
        }
        if (!isFormValid) return;
        setLoading(true);
        if (isPreview) {
            openAgreementPDFInNewTab()
            return
        }
        var raw = JSON.stringify({
            schoolId: LogInSchoolID,
            signature: signatureBase64,
            schoolName: agreementDetails.schoolname,
            streetLine1: agreementDetails.streetline1,
            streetLine2: agreementDetails.streetline2 || null,
            city: agreementDetails.city,
            state: agreementDetails.state,
            postalCode: agreementDetails.postalCode,
            country: "US",
            userId: LogInUserID,
            firstName: agreementDetails.firstname,
            LastName: agreementDetails.lastname
        });
        await ApiPostCall("/plans/insurance/parental-agreement/upload", raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                // setLoading(false);
                setSchoolAgreementPopup(false);
                // setSchoolAgreementPopupId('');
                setisSchoolAgreementFlag(1);
                setIsSchoolAgreementChecked(true)
                if (result == "success") {
                    setNewAlerts(<AlertsComp show={true} variant="success" msg={"Agreement Sign Successfully"} />);
                    setAgreementDetails({
                        ...agreementDetails, schoolname: "", streetline1: "", streetline2: "", city: "", state: "", postalCode: ""
                    });
                    setSignatureData(null);
                    GetGridData(null, null);
                    if (schoolAgreementPopupId) {
                        ConfirmContract(schoolAgreementPopupId, EditData.plan_num, EditData.plan_name, EditData.school_name, 1, 1)
                        setSchoolAgreementPopupId('');
                    }
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                        setLoading(false);
                    }, 1500);
                } else {
                    setNewAlerts(<AlertsComp show={true} variant="danger" msg={result} />);
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                    }, 1500);
                }
            }
        });
    }
    const openPDFInNewTab = (pdfurl) => {
        ApiGetCDNData("/" + pdfurl, StateData?.Schoolnumber).then((blob) => {
            try {
                const url = URL.createObjectURL(blob);
                if (url) window.open(url, '_blank');
            } catch (err) {
                log.error(err)
            }
        });
    };
    const openAgreementPDFInNewTab = async () => {
        try {
            const response = await fetch(dcc_administration_agreement);

            if (!response.ok) {
                throw new Error("DOCX template not found");
            }

            const content = await response.arrayBuffer();

            const zip = new PizZip(content);

            const doc = new Docxtemplater(zip, {
                paragraphLoop: true,
                linebreaks: true,
            });

            doc.render({
                Effective_Date: formattedDate,
                School_District_Name: agreementDetails?.schoolname || "",
                State: agreementDetails?.state || "",
                Address: `${agreementDetails?.streetline1 || ""}${agreementDetails?.streetline2 ? ", " + agreementDetails?.streetline2 : ""}${agreementDetails?.city ? ", " + agreementDetails?.city : ""}${agreementDetails?.postalCode ? " " + agreementDetails?.postalCode : ""}` || "",
            });

            const blob = doc.getZip().generate({
                type: "blob",
                mimeType:
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            });

            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.href = url;
            link.download = "Preview_Agreement.docx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);

        } catch (err) {
            log.error("DOCX generation error:", err);
        } finally {
            setLoading(false);
        }
    };
    const downloadDocFile = (docUrl) => {
        ApiGetCDNData("/" + docUrl, StateData?.Schoolnumber).then((blob) => {
            try {
                const url = URL.createObjectURL(blob);
                if (url) {
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = docUrl;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();

                    window.URL.revokeObjectURL(url);
                }
            } catch (err) {
                log.error(err)
            }
        });
    };
    return (
        <>
            {NewAlerts}
            {Loading ? <ShowLoder /> : <HideLoder />}
            {GridData?.length == 0 && mainimage == true && firstLoad && (
                <div className='row'>
                    <div className="col-12">
                        <div className="GridBox p-3">
                            <div className="greyBox p-3 data-table-container">
                                <div className='row '>
                                    <div className="col-md-12 font-16">

                                        <p className='secondary-text fw-bold'>
                                            {offset_repair_cost_prefix} <a className='text-decoration-underline whats-cover-text' href={services_dcc_link} target="_blank">{left_menu_dcc_text}</a> {offset_repair_cost_suffix}
                                        </p>
                                        <div className='py-3 text-center col-12'>
                                            <button className='mt-4 SaveBtn text-center'
                                                title="Create Your First Club"
                                                onClick={() => { navigate("/add-setup", { state: { id: 0 } }) }}>
                                                <label>+</label> Create Your First Club
                                            </button>
                                        </div>
                                        <div className='pt-3 col-12'>
                                            <p>
                                                <label onClick={(e) => openPDFInNewTab('Administration_Agreement.pdf')} className="cursor-pointer text-decoration-underline whats-cover-text" >Example agreement</label> for {dcc_module_text}.
                                            </p>
                                        </div>
                                        <label className='secondary-text fw-bold pb-3'>How It Works:</label>
                                        <ul className='secondary-text ps-5'>
                                            {how_it_works?.map((point, idx) => (
                                                <li key={idx}>
                                                    <b>{point?.title}</b> {point?.description}
                                                </li>
                                            ))}
                                        </ul>
                                        <label className='secondary-text fw-bold py-3'>Getting Started Is Simple:</label>
                                        <ol className='secondary-text ps-5'>
                                            {getting_started?.map((step, idx) => (
                                                <li key={idx}>
                                                    {step.text}
                                                    {step.sub_points && (
                                                        <ol type='a'>
                                                            {step.sub_points.map((sub, subIdx) => (
                                                                <li key={subIdx}>{sub}</li>
                                                            ))}
                                                        </ol>
                                                    )}
                                                </li>
                                            ))}
                                        </ol>
                                        <img src="/images/setupclub.png"
                                            className="img-fluid float-end ms-4 mb-3"
                                            style={{ maxWidth: "300px", height: "auto" }}
                                            alt="Device Club" />
                                        <label className='secondary-text fw-bold pt-3 pb-2'>{compliance_note_heading}</label>
                                        <p className='secondary-text'>
                                            {compliance_note_text}
                                        </p>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            )
            }
            {mainimage == false && !firstLoad &&
                <>
                    <div className="row pe-0 align-items-center mb-2 me-0">
                        <div className="col-md-5 d-flex align-items-center">
                            <h1 className="PageHeading m-0">Set Up {dcc_module_text}s</h1>
                            <div className="ps-2">
                                <OverlayTrigger
                                    trigger="click"
                                    placement="right"
                                    show={showPopover}
                                    onToggle={handleToggle}
                                    overlay={popover}
                                >
                                    <a href="#" role="button">
                                        <img src="/images/InfoBtn.svg" title={`What is ${dcc_module_text}?`} className="cursor-pointer" height='16px' />
                                    </a>
                                </OverlayTrigger>
                            </div>
                        </div>

                        <div className="col-md-1 px-0 text-center">
                            <u className={`${resetFilter} cursor-pointer`} onClick={(e) => { GetGridData(null, null); setsearchstring("") }}>Reset Filter</u>
                        </div>
                        <div className='col-md-3 pe-0 text-end SearchBarDivforloner'>
                            <form className="gridsearchbar" onSubmit={(e) => e.preventDefault()}>
                                <div className="position-absolute top-50 translate-middle-y search-icon ms-3 searchIcon"><i className="bi bi-search"></i></div>
                                <input className="form-control marginCss" autoComplete="off" type="text" placeholder="Search"
                                    onKeyUp={(e) => { GetGridData(SortFlag, e.target.value); setsearchstring(e.target.value) }}
                                    onKeyDown={(e) =>
                                        (["#", "?", "/", "\\"].includes(e.key) || (e.key == " " && !e.target.value)) &&
                                        e.preventDefault()
                                    } />
                            </form>
                        </div>
                        <div className="col-md-3 text-end pe-0">
                            <label className='col-12 BorderBtn text-center'
                                onClick={() => {
                                    navigate("/add-setup", { state: { id: 0 } });
                                }}>  Create Club
                                <img src='/images/AddInventory.svg' className='img-fluid ps-2' />
                            </label>
                        </div>
                    </div>
                    <div className='GridBox p-3'>
                        <div className="row pt-2 greyBox mx-0">
                            <div className="col-md-12 text-start pt-2">
                                {isSchoolAgreementFlag == 2 &&
                                    <>
                                        Your <b className="redText">Club Hosting Agreement</b> expired on <label className="redText">{MMDDYYYY(agreementExpiryDate)}</label>, <label className="highlight-part cursor-pointer text-decoration-underline"
                                            onClick={(e) => {
                                                GetAddress(); getpostalcodes(setallstate); setSchoolAgreementPopup(true)
                                            }}
                                        >Click here </label> to renew your agreement.
                                    </>
                                }
                                {isSchoolAgreementFlag == 1 &&
                                    <>
                                        Your <b>Club Hosting Agreement</b> is active and valid until {MMDDYYYY(agreementExpiryDate)}. <label className="highlight-part cursor-pointer text-decoration-underline"
                                            onClick={(e) => downloadDocFile(agreementFile)}
                                        >Click here </label> to view it.
                                    </>
                                }
                                {isSchoolAgreementFlag == 0 &&
                                    < div className="col-md-12 font-12 text-start ">
                                        <label onClick={(e) => openPDFInNewTab('Administration_Agreement.pdf')} className="cursor-pointer text-decoration-underline whats-cover-text">Example Agreement</label> for {dcc_module_text}. <label className="highlight-part cursor-pointer text-decoration-underline"
                                            onClick={(e) => {
                                                GetAddress(); getpostalcodes(setallstate); setSchoolAgreementPopup(true)
                                            }}
                                        >Click here </label> to sign the agreement.
                                    </div>
                                }
                                <p className="font-12 pe-0 pt-1">
                                    You can bill {students} for repairs if they are not enrolled in {dcc_module_text}. You can bill a flat fee per repair or the cost of a full repair. To set-up this feature, go to Settings {">"} {dcc_module_text} {">"} Unenrolled Repair Cost
                                </p>
                            </div>
                            {ContractUrl != null && ContractUrl != '' && (
                                <div className="col-md-12 pb-2">
                                    <label className="SaveBtn cursor-pointer align-item-center" onClick={() => GetSchoolData()}>
                                        Club Link and Fair Use Policy
                                    </label>
                                </div>
                            )}


                        </div>

                        <div className="col-12 greyBox p-3 mt-4">
                            <div className="row  align-items-center">
                                <div className="col-md-12 pb-4">
                                    <div className="d-flex justify-content-evenly align-items-center font-13">
                                        <div className={`cursor-pointer d-flex align-items-center ${activeFilter == 3 ? 'activePlanFilter' : ''}`}
                                            title="Filter" onClick={(e) => { setActiveFilter(3); setSortFlag(3); GetGridData(3, searchstring) }}>
                                            <div className="setup-status-square green-backgroung-style mx-3"></div><strong>Live</strong>
                                        </div>
                                        <div className={`cursor-pointer d-flex align-items-center ${activeFilter == 7 ? 'activePlanFilter' : ''}`}
                                            title="Filter" onClick={(e) => { setActiveFilter(7); setSortFlag(7); GetGridData(7, searchstring) }}>
                                            <div className="setup-status-square blue-backgroung-style mx-3"></div><strong>Live and Unenrolled</strong>
                                        </div>
                                        <div className={`cursor-pointer d-flex align-items-center ${activeFilter == 2 ? 'activePlanFilter' : ''}`}
                                            title="Filter" onClick={(e) => { setActiveFilter(2); setSortFlag(2); GetGridData(2, searchstring) }}>
                                            <div className="setup-status-square purple-backgroung-style mx-3"></div><strong>Waiting for Confirmation</strong>
                                        </div>
                                        <div className={`cursor-pointer d-flex align-items-center ${activeFilter == 1 ? 'activePlanFilter' : ''}`}
                                            title="Filter" onClick={(e) => { setActiveFilter(1); setSortFlag(1); GetGridData(1, searchstring) }}>
                                            <div className="setup-status-square yellow-backgroung-style mx-3"></div><strong>Newly Added</strong>
                                        </div>
                                        <div className={`cursor-pointer d-flex align-items-center ${activeFilter == 4 ? 'activePlanFilter' : ''}`}
                                            title="Filter" onClick={(e) => { setActiveFilter(4); setSortFlag(4); GetGridData(4, searchstring) }}>
                                            <div className="setup-status-square pink-backgroung-style mx-3"></div><strong>Past</strong>
                                        </div>

                                        {/* <div className={`cursor-pointer d-flex align-items-center ${activeFilter == 5 ? 'activePlanFilter' : ''}`}
                                            title="Filter" onClick={(e) => { setActiveFilter(5); setSortFlag(5); GetGridData(5, searchstring) }}>
                                            <div className="setup-status-square rejected-backgroung-style mx-3"></div><strong> In Negotiation</strong>
                                        </div> */}

                                        <div className={`cursor-pointer d-flex align-items-center ${activeFilter == 6 ? 'activePlanFilter' : ''}`}
                                            title="Filter" onClick={(e) => { setActiveFilter(6); setSortFlag(6); GetGridData(6, searchstring) }}>
                                            <div className="setup-status-square brown-backgroung-style mx-3"></div><strong>Rejected</strong>
                                        </div>

                                    </div>
                                </div>


                            </div>
                            <div className='row row-cols-1 row-cols-xl-3 row-cols-lg-2 row-cols-md-2 g-4 g-lg-4'>
                                {GridData?.length !== 0 ? (
                                    GridData?.map((item, i) => {
                                        var grades = sortGradesString(item.grades);
                                        return (
                                            <div className='col position-relative'>
                                                <div className='p-4 GridBox boxshaowstyle' style={{ maxHeight: '100%', minHeight: '100%', backgroundColor: item.color_code }}>
                                                    <div className="row align-items-center justify-content-between">
                                                        <div className="col-8">
                                                            <h4 className='mb-0 fw-600 planname-style' style={{ wordBreak: 'break-all', overflowWrap: 'break-word', maxWidth: '300px' }}>
                                                                {item.plan_name}
                                                            </h4>
                                                        </div>
                                                        <div className="col-4 px-0 mt-1 text-end d-flex flex-wrap justify-content-end">
                                                            {!item.deleted_at && <img src="/images/renewPlan.svg" className="cursor-pointer" title='Clone this club' height='16px' planid={item.id} onClick={(e) => navigate("/add-setup", { state: { id: item.id, isFromRenewClub: true } })} />}

                                                            {item.status == 1 && (
                                                                <>
                                                                    <img src="/images/EditPlan.svg" title="Edit Club" className="cursor-pointer ps-3" height='16px' onClick={(e) => { navigate("/add-setup", { state: { id: item.id } }) }} planid={item.id} />
                                                                    {!item.deleted_at && <img src="/images/DeleteIcon.svg" title="Delete Club" className="cursor-pointer ps-3" height="16px" onClick={(e) => { setplanid(item.id); setshowdeletepopup(true) }} />}
                                                                </>
                                                            )}
                                                            {item.status == 2 && (
                                                                <>
                                                                    <img src="/images/setupapprove.svg" className="cursor-pointer ps-2 mb-1"
                                                                        title={`Confirm ${dcc_module_text}`} height='16px'
                                                                        onClick={(e) => {
                                                                            // if (isSchoolAgreementFlag === 1) {
                                                                            ViewDetails(item.id);
                                                                            // } else {
                                                                            // setSchoolAgreementPopupId(item.id);
                                                                            // setSchoolAgreementPopup(true);
                                                                            // }

                                                                        }}
                                                                        planid={item.id} />
                                                                    <img src="/images/downloadPlan.svg" className="cursor-pointer ps-2 mb-1" title={`Preview ${dcc_module_text}`} height='16px' onClick={(e) => openPDFInNewTab(item.pdf)} planid={item.id} />
                                                                    {!item.deleted_at && <img src="/images/DeleteIcon.svg" title="Delete Club" className="cursor-pointer ps-2 mb-1" height="16px" onClick={(e) => { setplanid(item.id); setshowdeletepopup(true) }} />}
                                                                </>
                                                                // <div className="d-flex flex-wrap">
                                                                //     <img src="/images/EditPlan.svg" title="Edit Club" className="cursor-pointer mb-1" height='16px' onClick={(e) => { navigate("/add-setup", { state: { id: item.id } }) }} planid={item.id} />

                                                                // </div>
                                                            )}
                                                            {item.status == 5 && (
                                                                <>
                                                                    {/* <img src="/images/EditPlan.svg" title="Edit Club" className="cursor-pointer ps-3" height='16px' onClick={(e) => { navigate("/add-setup", { state: { id: item.id } }) }} planid={item.id} /> */}
                                                                    {!item.deleted_at && <img src="/images/DeleteIcon.svg" title="Delete Club" className="cursor-pointer ps-3" height="16px" onClick={(e) => { setplanid(item.id); setshowdeletepopup(true) }} />}
                                                                </>
                                                            )}
                                                            {item.status == 3 && (
                                                                <img src="/images/downloadPlan.svg" className="cursor-pointer ps-3" title={`Preview ${dcc_module_text}`} height='16px' onClick={(e) => openPDFInNewTab(item.pdf)} planid={item.id} />
                                                            )}
                                                            {item.status == 4 && !item.deleted_at && (
                                                                <>
                                                                    {/* <FontAwesomeIcon icon={faCopy} style={{ height: "16px" }} className='cursor-pointer ps-3' title="Renew Device Complete Club" titleId="Renew Device Complete Club" onClick={(e) => navigate("/add-setup", { state: { id: item.id, isFromRenewClub: true } })} /> */}
                                                                    <img src="/images/downloadPlan.svg" className="cursor-pointer ps-3" title={`Preview ${dcc_module_text}`} height='16px' onClick={(e) => openPDFInNewTab(item.pdf)} planid={item.id} />
                                                                    {!item.deleted_at && <img src="/images/DeleteIcon.svg" title="Delete Club" className="cursor-pointer ps-3" height="16px" onClick={(e) => { setplanid(item.id); setshowdeletepopup(true) }} />}
                                                                </>
                                                            )}
                                                            {item.status == 6 && (
                                                                <>
                                                                    {/* <img src="/images/EditPlan.svg" title="Edit Club" className="cursor-pointer ps-3" height='16px' onClick={(e) => { navigate("/add-setup", { state: { id: item.id } }) }} planid={item.id} /> */}
                                                                    {!item.deleted_at && <img src="/images/DeleteIcon.svg" title="Delete Club" className="cursor-pointer ps-3" height="16px" onClick={(e) => { setplanid(item.id); setshowdeletepopup(true) }} />}
                                                                </>
                                                            )}
                                                            {item.status == 7 && (
                                                                <img src="/images/downloadPlan.svg" className="cursor-pointer ps-3" title={`Preview ${dcc_module_text}`} height='16px' onClick={(e) => openPDFInNewTab(item.pdf)} planid={item.id} />
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                        <div className='mt-3 content-forsetupcards'><span className="fw-600">Estimated {student} :</span> {item.estimated_enrollment}</div>
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                        <div className='mt-2 content-forsetupcards'><span className="fw-600">Sign Up Start Date :</span> {item.start_date ? MMDDYYYY(item.start_date) : '-'}</div>
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                        <div className='mt-2 content-forsetupcards'><span className="fw-600">Sign Up End Date :</span> {item.end_date ? MMDDYYYY(item.end_date) : '-'}</div>
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                        <div className='mt-2 content-forsetupcards'><span className="fw-600">Club Start Date :</span> {item.coverage_start_date ? MMDDYYYY(item.start_date) : '-'}</div>
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                        <div className='mt-2 content-forsetupcards'><span className="fw-600">Club End Date :</span> {item.coverage_end_date ? MMDDYYYY(item.coverage_end_date) : '-'}</div>
                                                    </div>
                                                    <div className="d-flex align-items-center justify-content-between">
                                                        <div className='mt-2 content-forsetupcards'><span className="fw-600">Access Code :</span> {item.access_code}</div>
                                                    </div>
                                                    <div className='mt-2 content-forsetupcards' ><span className="fw-600">Grades : </span>
                                                        {item.grades ? grades : '-'}
                                                    </div>
                                                    <div className='mt-2 content-forsetupcards' ><span className="fw-600">Previous Grades : </span>
                                                        {item.previous_grades ? item.previous_grades : '-'}
                                                    </div>
                                                    <div className='mt-2 content-forsetupcards text-break' ><span className="fw-600">Shopify Link : </span>
                                                        <a href={item.shopify_link} target="_blank" rel="noopener noreferrer">
                                                            {item.shopify_link ? item.shopify_link : '-'}
                                                        </a>
                                                    </div>
                                                    <div className='mt-2 mb-3 content-forsetupcards' ><span className="fw-600">Discount Code : </span>
                                                        {item.discount_code ? item.discount_code : '-'}
                                                    </div>
                                                    {item.price != null && (<div className='h5 total-price'><b>Total Prices : ${formatDecimal(item.price)}</b></div>)}
                                                </div>
                                            </div>
                                        )
                                    })
                                ) : (
                                    <div className='m-auto py-5'>
                                        <div className="col-md-12 text-center h3">No Record Found</div>
                                        <div className='m-auto py-5'>
                                            <img src='/images/setupplanicon.svg' className="img-fluid" />
                                        </div>
                                    </div>
                                )}
                            </div>
                            {showPagination && (
                                <Pagination
                                    activePage={currentPage}
                                    itemsCountPerPage={itemsPerPage}
                                    totalItemsCount={pageRangeCount}
                                    pageRangeDisplayed={15}
                                    onChange={(e) => setCurrentPage(e)}
                                    color="primary"
                                    lastPageText=""
                                    firstPageText=""
                                    itemClassFirst="MasterClass"
                                    itemClassPrev="MasterClass"
                                    itemClassNext="MasterClass"
                                    itemClassLast="MasterClass"
                                    hideFirstLastPages={true} />
                            )}
                        </div>
                    </div >
                </>
            }
            <Deletepopup text={`You won't be able to revert this!`} deletePopup={showdeletepopup} deletePart={DeletePlan} DeleteShowClose={(e) => setshowdeletepopup(false)}></Deletepopup>

            <Popup isshow={schoolAgreementPopup ? false : ContractModal} size={"lg"} title={`Review & Confirm ${enterprise_name}'s Charges`}
                closePopup={(e) => setContractModal(false)}
                modalBody={modalbody} modalfooter={modalfooter} />

            <Popup isshow={policyPopup} size={"md"} title={"Club Link and Fair Use Policy Pop-Up"}
                closePopup={(e) => { setPolicyPopup(false); setshowcopymsg(false); setPolicyFileName(''); setPolicyDocument(null) }}
                modalBody={policypopup} handleSave={UploadPolicyDocument} visibleSaveBtn={true} btnText={"Update"} />

            <Popup isshow={schoolAgreementPopup} size={"md"} title={"Club Hosting Agreement"}
                closePopup={(e) => { setSchoolAgreementPopup(false); setSchoolAgreementPopupId(''); }}
                modalBody={agreementmodalbody} handleSave={() => handleSignAgreement(false)} visibleSaveBtn={true} btnText={"Sign Agreement"} />

        </>
    )
}
